import React from 'react'
import {IconProps} from '../../types/IconProps'

const IconPin = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '20'}
      height={height || '22'}
      viewBox={`0 0 ${width || 20} ${height || 2}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='Path (Stroke)'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.7599 1.51959C12.8738 -0.506529 16.3007 -0.506529 18.4146 1.51959C20.5285 3.5457 20.5285 6.83034 18.4146 8.85646L9.85189 17.0637C8.5538 18.3079 6.44823 18.3079 5.15014 17.0637C3.85204 15.8195 3.85204 13.8013 5.15014 12.5571L11.6456 6.33134C11.9657 6.02452 12.4847 6.02452 12.8048 6.33134C13.1249 6.63816 13.1249 7.13561 12.8048 7.44244L6.30936 13.6682C5.65148 14.2988 5.65148 15.322 6.30936 15.9526C6.96724 16.5831 8.0348 16.5831 8.69267 15.9526L17.2554 7.74536C18.729 6.33289 18.729 4.04316 17.2554 2.63068C15.7817 1.21821 13.3928 1.21821 11.9192 2.63068L3.35646 10.8379C1.06703 13.0323 1.06703 16.5885 3.35646 18.7829C5.64589 20.9773 9.35614 20.9773 11.6456 18.7829L16.8422 13.802C17.1623 13.4952 17.6813 13.4952 18.0014 13.802C18.3215 14.1089 18.3215 14.6063 18.0014 14.9131L12.8048 19.894C9.87514 22.702 5.12689 22.702 2.19724 19.894C-0.732413 17.086 -0.732413 12.5348 2.19724 9.7268L10.7599 1.51959Z'
        fill={color || 'black'}
      />
    </svg>
  )
}

export default IconPin
